import { type LocationResponse, RegionType } from "@b2bportal/air-shopping-api";
import { locationCodeToITripTerminus } from "@b2bportal/core-utilities";
import { IdEnum, type ITripTerminus } from "@hopper-b2b/types";

const IATA_CODE_PATTERN = /^[A-Z]{3}$/;

export function normalizeFlightRegionType(
  regionType?: string
): RegionType | undefined {
  const normalizedRegionType = regionType?.trim().toLowerCase();

  if (normalizedRegionType === RegionType.airport) {
    return RegionType.airport;
  }

  if (normalizedRegionType === RegionType.city) {
    return RegionType.city;
  }

  return undefined;
}

export function resolveFlightLocation(
  response: LocationResponse,
  locationCode: string,
  regionType?: string
): ITripTerminus | undefined {
  const normalizedCode = locationCode.trim().toUpperCase();
  const normalizedRegionType = normalizeFlightRegionType(regionType);
  const exactMatch = response.categories
    ?.flatMap((category) => category.results ?? [])
    .find(
      (result) =>
        result.id.Id === IdEnum.Flight &&
        result.id.code.code.toUpperCase() === normalizedCode
    );

  if (exactMatch) {
    return exactMatch as ITripTerminus;
  }

  if (!IATA_CODE_PATTERN.test(normalizedCode) || !normalizedRegionType) {
    return undefined;
  }

  // Price-watch links already carry the canonical code and region type.
  // Keep the shop usable when label autocomplete omits that exact location.
  return locationCodeToITripTerminus(normalizedCode, normalizedRegionType);
}
